import type { Nullable } from 'nuqs'

type PersistAdapter = {
  set: (key: string | number | symbol, value: string) => void
  remove: (key: string | number | symbol) => void
}

// biome-ignore lint/suspicious/noExplicitAny: serializer param types differ per key; `unknown` would reject every concrete serializer (contravariance) and `never` would forbid calling it.
export type SerializableParser = { serialize: (value: any) => string }

/**
 * Persists explicitly-updated keys to storage. Keys absent from `updates` are
 * untouched; keys explicitly set to null/undefined have their stored value
 * removed so a cleared value cannot resurrect from the cookie on a later
 * navigation.
 */
export function persistUpdates<T extends Record<string, unknown>>(
  updates: Partial<Nullable<T>>,
  persist: (keyof T)[] | undefined,
  schema: Record<keyof T, SerializableParser>,
  adapter: PersistAdapter
): void {
  persist?.forEach(key => {
    if (!(key in updates)) return

    const value = updates[key]

    if (value === null || value === undefined) {
      adapter.remove(key)
      return
    }

    adapter.set(key, schema[key].serialize(value))
  })
}
